import React from 'react';

const HomeIcon: React.FC = () => (
  <svg
    fill="none"
    height="1em"
    viewBox="0 0 24 23"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.80774 7.84619C4.80774 7.57005 4.58388 7.34619 4.30774 7.34619C4.0316 7.34619 3.80774 7.57005 3.80774 7.84619H4.80774ZM20.1924 7.84619C20.1924 7.57005 19.9685 7.34619 19.6924 7.34619C19.4162 7.34619 19.1924 7.57005 19.1924 7.84619H20.1924ZM19.6924 20.9231V21.4231C19.9685 21.4231 20.1924 21.1993 20.1924 20.9231H19.6924ZM4.30774 20.9231H3.80774C3.80774 21.1993 4.0316 21.4231 4.30774 21.4231V20.9231ZM15.077 20.9231H14.577C14.577 21.1993 14.8008 21.4231 15.077 21.4231V20.9231ZM8.92312 20.9231V21.4231C9.19927 21.4231 9.42312 21.1993 9.42312 20.9231H8.92312ZM19.1924 7.84619V20.9231H20.1924V7.84619H19.1924ZM4.80774 20.9231V7.84619H3.80774V20.9231H4.80774ZM19.6924 20.4231H15.077V21.4231H19.6924V20.4231ZM8.92312 20.4231H4.30774V21.4231H8.92312V20.4231ZM15.577 20.9231V14.1026H14.577V20.9231H15.577ZM13.077 11.6026H12V12.6026H13.077V11.6026ZM12 11.6026H10.9231V12.6026H12V11.6026ZM8.42312 14.1026V20.9231H9.42312V14.1026H8.42312ZM10.9231 11.6026C9.54241 11.6026 8.42312 12.7219 8.42312 14.1026H9.42312C9.42312 13.2742 10.0947 12.6026 10.9231 12.6026V11.6026ZM15.577 14.1026C15.577 12.7219 14.4577 11.6026 13.077 11.6026V12.6026C13.9054 12.6026 14.577 13.2742 14.577 14.1026H15.577Z"
      fill="currentColor"
    />
    <path
      d="M2 8.61538L12 4L22 8.61538"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { HomeIcon };
